import externalLinks from "../../../constants/externalLinks";
import { BASENAME } from "../../../router/constants";
import FooterItem from "../FooterItem";
import FooterSection from "../FooterSection";

const FooterNavigationSection = ({ className = "" }) => (
  <FooterSection titleId="footer.navigation" className={className}>
    <FooterItem
      messageId="footer.browse_popular"
      href={externalLinks.browsePopular}
    />
    <FooterItem
      messageId="footer.browse_simulcasts"
      href={externalLinks.browseSimulcasts}
    />
    <FooterItem messageId="footer.browse_manga" href={externalLinks.manga} />
    <FooterItem
      messageId="footer.release_calendar"
      href={externalLinks.releaseCalendar}
    />
    <FooterItem messageId="footer.news" href={`/${BASENAME}`} />
    <FooterItem messageId="footer.store" href={externalLinks.store} />
    <FooterItem messageId="footer.games" href={externalLinks.games} />
  </FooterSection>
);

export default FooterNavigationSection;
